/* bleed.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._2YLqiKjCgj%7Bmargin-inline%3Avar(--ds-space-negative-025%2C-.125rem)%7D%0A._2YLqiKkVoo%7Bmargin-inline%3Avar(--ds-space-negative-050%2C-.25rem)%7D%0A._2YLqiKdeGH%7Bmargin-inline%3Avar(--ds-space-negative-100%2C-.5rem)%7D%0A._2YLqiKRg7s%7Bmargin-inline%3Avar(--ds-space-negative-150%2C-.75rem)%7D%0A._2YLqiKA6iX%7Bmargin-inline%3Avar(--ds-space-negative-200%2C-1rem)%7D%0A._3SamIHjCgj%7Bmargin-block%3Avar(--ds-space-negative-025%2C-.125rem)%7D%0A._3SamIHkVoo%7Bmargin-block%3Avar(--ds-space-negative-050%2C-.25rem)%7D%0A._3SamIHdeGH%7Bmargin-block%3Avar(--ds-space-negative-100%2C-.5rem)%7D%0A._3SamIHRg7s%7Bmargin-block%3Avar(--ds-space-negative-150%2C-.75rem)%7D%0A._3SamIHA6iX%7Bmargin-block%3Avar(--ds-space-negative-200%2C-1rem)%7D");










import React, { type JSX, type ReactNode } from 'react';
import type { BasePrimitiveProps, BleedSpaceToken } from './types';
export type BleedProps = {
  /**
   * Elements to be rendered inside the Flex.
   */
  children: ReactNode;
  /**
   * Bleed along both axis.
   */
  all?: BleedSpaceToken;
  /**
   * Bleed along the inline axis.
   */
  inline?: BleedSpaceToken;
  /**
   * Bleed along the block axis
   */
  block?: BleedSpaceToken;
} & BasePrimitiveProps;

// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const styles = {
  root: "_24h04i2Njc",
  'inline.space.025': "_2YLqiKjCgj",
  'inline.space.050': "_2YLqiKkVoo",
  'inline.space.100': "_2YLqiKdeGH",
  'inline.space.150': "_2YLqiKRg7s",
  'inline.space.200': "_2YLqiKA6iX",
  'block.space.025': "_3SamIHjCgj",
  'block.space.050': "_3SamIHkVoo",
  'block.space.100': "_3SamIHdeGH",
  'block.space.150': "_3SamIHRg7s",
  'block.space.200': "_3SamIHA6iX"
};

/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */
export const Bleed: React.MemoExoticComponent<({
  children,
  testId,
  inline,
  block,
  all,
  xcss
}: BleedProps) => JSX.Element> = React.memo(({
  children,
  testId,
  inline,
  block,
  all,
  xcss
}: BleedProps): JSX.Element => {
  return <div className={ax([styles.root, all && styles[(`inline.${all}` as const)], inline && styles[(`inline.${inline}` as const)], all && styles[(`block.${all}` as const)], block && styles[(`block.${block}` as const)], xcss])} data-testid={testId}>
			{children}
		</div>;
});
Bleed.displayName = 'Bleed';